import React, { useEffect, useState } from "react";
import Search from "../form/Search";
import Deliver from "../Cards/Deliver";
import DishIcon from "../../assets/images/svgs/cards/dish.svg";
import DeliveryIcon from "../../assets/images/svgs/cards/delivery.svg";
import OrdersIcon from "../../assets/images/svgs/cards/orders.svg";
import { LuSun, LuMoon } from "react-icons/lu";
import DeleteSwal from "../Swals/DeleteSwal";
import { useNavigate } from "react-router-dom";
import CardShimmer from "../Preloader/CardShimmer";
import { useDispatch, useSelector } from "react-redux";
import { getOrderList, onCancelOrder } from "../../redux/thunks/orderThunk";
import toast from "react-hot-toast";
import { FileMinus } from "lucide-react";
import { MdOutlineCancel } from "react-icons/md";
import { encryptId } from "../../utils/urlCrypto";

const normalizeStatus = (status) => {
  if (!status || status === "all") return undefined;
  if (status === "cancelled") return "cancelled";
  return status;
};

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center items-center gap-2 mt-6">
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="px-3 py-1 border rounded disabled:opacity-40"
      >
        Prev
      </button>

      {Array.from({ length: totalPages }).map((_, i) => {
        const page = i + 1;
        return (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 border rounded ${
              page === currentPage ? "bg-[#FF7043] text-white" : "bg-white"
            }`}
          >
            {page}
          </button>
        );
      })}

      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="px-3 py-1 border rounded disabled:opacity-40"
      >
        Next
      </button>
    </div>
  );
};

const Dashtabs = ({ filterStatus, mealTiming }) => {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("all");
  const [searchval, setSearchval] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [Curr, setCurr] = useState(false);

  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    tabCounts = {},
    getOrders,
    pagination,
    search,
  } = useSelector((state) => state.order);
  const { current_page, total_pages } = pagination;

  const ordersArray = Array.isArray(getOrders)
    ? getOrders
    : getOrders?.orders || [];

  useEffect(() => {
    setPage(1);
  }, [mealTiming, search, filterStatus]);

  useEffect(() => {
    setLoading(true); // 🔥 shimmer ON

    dispatch(
      getOrderList({
        page,
        page_type: "dashboard",
        search,
        status: normalizeStatus(filterStatus),
        meal_timing: mealTiming === "all" ? undefined : mealTiming,
      }),
    )
      .unwrap()
      .then((res) => {
        const currencySym = res.data?.currency_symbol;
        setCurr(currencySym);
      })
      .finally(() => {
        setLoading(false); // 🔥 shimmer OFF
      });
  }, [page, search, filterStatus, dispatch, mealTiming]);

  const tabWiseCounts = {
    all: ordersArray.length,
    pickup: ordersArray.filter((o) => o.delivery_type === "Pickup").length,
    delivery: ordersArray.filter((o) => o.delivery_type === "Delivery").length,
  };

  const TABS = [
    { label: "All", value: "all" },
    { label: "Home Delivery", value: "delivery" },
    { label: " Pick Up", value: "pickup" },
  ];

  // Tab click pe shimmer
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setLoading(true);

    document.activeElement?.blur();

    setTimeout(() => {
      setLoading(false);
    }, 600);
  };

  const handleCancel = async (orderId) => {
    DeleteSwal({
      title: "Cancel order?",
      text: "Are you sure you want to cancel this order?",
      icon: MdOutlineCancel,
      confirmText: "Yes Cancel",
      cancelText: "No",
      note: "",
      cancleColor: "",
      onConfirm: async () => {
        const order = ordersArray.find((o) => o.order_id === orderId);
        if (!order) return;

        const payload = {
          order_id: order.order_id,
          service_provider_customer_id: order.service_provider_customer_id,
          is_confirmed: 1,
        };
        // console.log("The payload is :", payload);

        try {
          const res = await dispatch(onCancelOrder(payload)).unwrap();
          if (res.success) {
            toast.success(res.message || "Order cancelled successfully");
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          } else {
            toast.error(res.message || "Failed to cancel order");
          }
        } catch (err) {
          console.error(err);
          toast.error("Something went wrong!");
        }
      },
    });
  };

  const formatDateTime12 = (dateTime) => {
    if (!dateTime) return "";
    const date = new Date(dateTime.replace(" ", "T"));
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour12: true,
    });
  };
  // useEffect(() => {
  //   console.log("Redux getOrders 👉", getOrders);
  // }, [getOrders]);

  // Reusable render function

  const mapOrderToCard = (order) => {
    const initials = order.customer_name
      ?.trim()
      .split(" ")
      .filter(Boolean) // extra spaces hatao
      .slice(0, 2) // 🔥 sirf first 2 words
      .map((n) => n[0])
      .join("")
      .toUpperCase();

    return {
      orderId: order.order_id,
      initial: initials,
      title: order.customer_name,
      date: formatDateTime12(order.order_date),
      description: order.meal_name,
      descIcon: OrdersIcon,
      delType: order.delivery_type === "Pickup" ? "Pick up" : "Home Delivery",
      delIcon: DeliveryIcon,
      itemIcon: DishIcon,
      items: order.quantity,
      mealIcon:
        order.meal_timing === "Lunch" ? (
          <LuSun size={18} />
        ) : (
          <LuMoon size={18} />
        ),
      mealtype: order.meal_timing,
      price: `${Curr} ${Number(order.amount).toFixed(2)}`,
      deliveryTypeRaw: order.delivery_type,
    };
  };

  const getFilteredOrders = () => {
    let filtered = ordersArray;

    // TAB filter
    if (activeTab === "delivery") {
      filtered = filtered.filter((o) => o.delivery_type === "Delivery");
    }

    if (activeTab === "pickup") {
      filtered = filtered.filter((o) => o.delivery_type === "Pickup");
    }

    // SEARCH filter (debounced)
    if (debouncedSearch.trim()) {
      const q = debouncedSearch.toLowerCase();

      filtered = filtered.filter(
        (o) =>
          o.customer_name?.toLowerCase().includes(q) ||
          o.meal_name?.toLowerCase().includes(q) ||
          String(o.order_id).includes(q) ||
          o.customer_mobile?.includes(q),
      );
    }

    return filtered;
  };

  useEffect(() => {
    setSearchLoading(true);

    const timer = setTimeout(() => {
      setDebouncedSearch(searchval);
      setSearchLoading(false);
    }, 400); // 🔥 debounce time

    return () => clearTimeout(timer);
  }, [searchval]);

  const renderOrders = (data) => {
    return (
      <div className={`grid grid-cols-1 gap-4 md:grid-cols-2`}>
        {data.map((item) => (
          <Deliver
            key={item.orderId}
            from={"dashboard"}
            to={`/order-details/${encryptId(item.orderId)}`}
            initial={item.initial}
            title={item.title}
            date={item.date}
            formattedDate={item.date}
            description={item.description}
            descIcon={item.descIcon}
            delType={item.delType}
            delIcon={item.delIcon}
            itemIcon={item.itemIcon}
            items={item.items}
            mealIcon={item.mealIcon}
            mealType={item.mealtype}
            price={item.price}
            onCanClick={() => handleCancel(item.orderId)}
            onDeliclick={() =>
              navigate(`/order-delivery/${encryptId(item.orderId)}`)
            }
          />
        ))}
      </div>
    );
  };

  return (
    <section className="flex justify-center">
      <div className="w-full max-w-7xl flex flex-col gap-4">
        {/* <div className="w-full mx-auto max-w-xl">
          <Search searchValue={searchval} onSearch={setSearchval} /
          >
        </div> */}

        {/* Tabs */}
        <div className="w-full ">
          <div
            className="
              flex items-center justify-around md:justify-evenly 
              gap-2 md:gap-6 p-2 
              border border-[#FF6943] rounded-full 
              md:border-0 
              md:border-b 
              md:border-[#FF7043] 
              md:rounded-none
              md:pb-3
              md:shadow-[0_2px_6px_rgba(0,0,0,0.04)]
            "
          >
            {TABS.map((tab) => (
              <button
                key={tab.value}
                onClick={() => handleTabClick(tab.value)}
                className={`relative font-semibold text-xs sm:text-sm px-4 py-1.5 transition-all duration-200

      ${
        activeTab === tab.value
          ? "bg-[#FF7043] text-white rounded-full   md:bg-[#FF7043]"
          : "bg-white text-gray-700 border border-[#EBEBEB] rounded-full md:border-none hover:text-[#FF7043]"
      }
      `}
              >
                {tab.label}

                {/* COUNT BADGE */}
                {tabWiseCounts[tab.value] ? (
                  <span
                    className={`absolute -top-2 -right-2 text-[10px] md:text-[10px] font-bold h-5 min-w-[1.25rem] px-2 flex justify-center items-center rounded-full border border-gray-100 
    ${
      activeTab === tab.value
        ? "bg-white text-black"
        : "bg-red-100 text-red-500"
    } whitespace-nowrap`}
                  >
                    {" "}
                    {tabWiseCounts[tab.value] || ""}
                  </span>
                ) : (
                  ""
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Search */}
        <Search searchValue={searchval} onSearch={setSearchval} />

        {/* Tab Content */}
        <div id="tabContent" className="mt-4 relative min-h-[420px]">
          {/* ACTUAL CONTENT (always mounted) */}
          <div className={loading ? "opacity-40 pointer-events-none" : ""}>
            {searchLoading ? (
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {Array(3)
                  .fill(0)
                  .map((_, i) => (
                    <CardShimmer key={i} />
                  ))}
              </div>
            ) : getFilteredOrders().length === 0 ? (
              <div className="col-span-full flex justify-center items-center py-10 text-gray-400">
                <div className="text-center flex flex-col items-center space-y-3">
                  <FileMinus size={65} className="text-gray-300" />
                  <h1 className="text-lg font-semibold text-gray-700">
                    No Booking Found
                  </h1>
                  <p className="text-sm text-gray-500">
                    No orders for the selected filter
                  </p>
                </div>
              </div>
            ) : (
              renderOrders(getFilteredOrders().map(mapOrderToCard))
            )}
          </div>

          {/* SHIMMER OVERLAY (tab change + api load) */}
          {loading && (
            <div className="absolute inset-0 bg-white z-10">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {Array(3)
                  .fill(0)
                  .map((_, i) => (
                    <CardShimmer key={i} />
                  ))}
              </div>
            </div>
          )}
        </div>

        <Pagination
          currentPage={current_page}
          totalPages={total_pages}
          onPageChange={(p) => setPage(p)}
        />
      </div>
    </section>
  );
};

export default Dashtabs;
